import {
  PLAN_GET_ALL_MAKE_JJDW_ACTIONS_BEGIN,
  PLAN_GET_ALL_MAKE_JJDW_ACTIONS_SUCCESS,
  PLAN_GET_ALL_MAKE_JJDW_ACTIONS_FAILURE,
  PLAN_GET_ALL_MAKE_JJDW_ACTIONS_DISMISS_ERROR,
} from './constants';
import request from '../../../utils/request'
// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function getAllMakeJjdwActions(params) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: PLAN_GET_ALL_MAKE_JJDW_ACTIONS_BEGIN,
    });

    // Return a promise so that you could control UI flow without states in the store.
    // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
    // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
    // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
    const promise = new Promise((resolve, reject) => {
      // doRequest is a placeholder Promise. You should replace it with your own logic.
      // See the real-word example at:  https://github.com/supnate/rekit/blob/master/src/features/home/redux/fetchRedditReactjsList.js
      // args.error here is only for test coverage purpose.
     request({
       url:"/api/basic/made/jj/unit",
       method:"get"
     }).then(
        (res) => {
          dispatch({
            type: PLAN_GET_ALL_MAKE_JJDW_ACTIONS_SUCCESS,
            data: res,
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: PLAN_GET_ALL_MAKE_JJDW_ACTIONS_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissGetAllMakeJjdwActionsError() {
  return {
    type: PLAN_GET_ALL_MAKE_JJDW_ACTIONS_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case PLAN_GET_ALL_MAKE_JJDW_ACTIONS_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        getAllMakeJjdwActionsPending: true,
        getAllMakeJjdwActionsError: null,
      };

    case PLAN_GET_ALL_MAKE_JJDW_ACTIONS_SUCCESS:
      // The request is success
      console.log(action.data.data)
      let id = {}
      let list = []
      action.data.data.map(item => id[item.id] = item)
      action.data.data.map(item => list.push(item.id))
      return {
        ...state,
        getAllMakeJjdwList:list,
        getAllMakeJjdwId:id,
        getAllMakeJjdwActionsPending: false,
        getAllMakeJjdwActionsError: null,
      };

    case PLAN_GET_ALL_MAKE_JJDW_ACTIONS_FAILURE:
      // The request is failed
      return {
        ...state,
        getAllMakeJjdwActionsPending: false,
        getAllMakeJjdwActionsError: action.data.error,
      };

    case PLAN_GET_ALL_MAKE_JJDW_ACTIONS_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        getAllMakeJjdwActionsError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/plan/redux/getAllMakeJjdwActions.js